'use client';
import { useTheme } from '@/providers/ThemeProvider';
import { cn } from '@pulsex/utils';

interface ThemeToggleProps {
    className?: string;
    iconSize?: number;
}

export const ThemeToggle = ({ className, iconSize = 24 }: ThemeToggleProps) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className={cn(
                'rounded-full border transition-all duration-200 grid place-items-center',
                'hover:bg-greyBackgroundDim/20',
                'focus:outline-none focus:ring-2 focus:ring-masterRed/50',
                className
            )}
            aria-label={theme === 'light' ? 'تفعيل الوضع الداكن' : 'تفعيل الوضع الفاتح'}
            title={theme === 'light' ? 'الوضع الداكن' : 'الوضع الفاتح'}
        >
            {theme === 'light' ? (
                // Moon icon for switching to dark mode
                <MoonIcon size={iconSize} className="fill-black" />
            ) : (
                // Sun icon for switching to light mode
                <SunIcon size={iconSize} className="fill-yellow-400" />
            )}
        </button>
    );
};

// Moon Icon Component
const MoonIcon = ({ size = 24, className }: { size?: number; className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className={className}
    >
        <path d="M21.64 13a1 1 0 0 0-1.05-.14 8.05 8.05 0 0 1-3.37.73 8.15 8.15 0 0 1-8.14-8.1 8.59 8.59 0 0 1 .25-2A1 1 0 0 0 8 2.36a10.14 10.14 0 1 0 14 11.69 1 1 0 0 0-.36-1.05zm-9.5 6.69A8.14 8.14 0 0 1 7.08 5.22v.27a10.15 10.15 0 0 0 10.14 10.14 9.79 9.79 0 0 0 2.1-.22 8.11 8.11 0 0 1-7.18 4.32z" />
    </svg>
);

// Sun Icon Component
const SunIcon = ({ size = 24, className }: { size?: number; className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className={className}
    >
        <path d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM11 1h2v3h-2V1zm0 19h2v3h-2v-3zM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93zM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121zm2.121-14.85l1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121zM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121zM23 11v2h-3v-2h3zM4 11v2H1v-2h3z" />
    </svg>
);

export default ThemeToggle;
